export default {
  AUTO: 'auto',
}
